var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,45.852c5.532,0,10.033-4.501,10.033-10.034S53.532,25.785,48,25.785c-5.533,0-10.034,4.501-10.034,10.034 S42.467,45.852,48,45.852z M48,29.785c3.327,0,6.033,2.707,6.033,6.034S51.327,41.852,48,41.852s-6.034-2.707-6.034-6.034 S44.673,29.785,48,29.785z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,48.05c-8.751,0-15.985,6.84-16.468,15.571c-0.039,0.697,0.29,1.364,0.865,1.759C37.004,68.543,42.4,70.215,48,70.215 c5.6,0,10.995-1.672,15.603-4.835c0.576-0.395,0.903-1.062,0.865-1.759C63.984,54.89,56.751,48.05,48,48.05z M48,66.215 c-4.397,0-8.647-1.205-12.361-3.496C36.524,56.652,41.751,52.05,48,52.05c6.249,0,11.476,4.603,12.361,10.669 C56.646,65.01,52.397,66.215,48,66.215z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.262578d7a8332f244b52cd360a8c492d.svg";
export { ForwardRef as ReactComponent };